export function buildQueryString(query, path = "") {
    let querystring = "";

    if (query) {
        let isFirst = !path.includes("?");

        for (let key in query) {
            if (typeof query[key] !== "undefined" && query[key] !== null) {
                querystring += (isFirst ? "?" : "&") + key + "=" + encodeURIComponent(query[key].toString());
                isFirst = false;
            }
        }
    }
    return querystring;
}

export function updateCurrentURL(param, value) {
    const newURL = new URL(window.location.href);
    const searchParams = newURL.searchParams;

    if (value) searchParams.set(param, value);
    else searchParams.delete(param);

    window.history.pushState({ path: newURL.href }, "", newURL.href);
}

export function updateCurrentURLV2(param, value, graphQLLike, asyncValue) {
    const newURL = new URL(window.location.href);
    const searchParams = newURL.searchParams;
    let extractedSearchVal = "";
    if (asyncValue) {
        extractedSearchVal = asyncValue.split("=").pop();
    }
    if (value && value.includes(extractedSearchVal) && graphQLLike) {
        /**
         * Since selectheaderv2 calls the async function 2x:
         * On search and on header selection, the filter may be
         * interpreted as =like=. This is a workaround to avoid this.
         */
        const likeVal = "like=" + extractedSearchVal;
        value = value.filter((filter) => filter !== extractedSearchVal); // Like filter is also included in the value array, but we need to differentiate like and non-like filters.
        value = [...value, likeVal];
    }

    let finalValArr = [];

    if (value) {
        if(Array.isArray(value)){
            value.forEach((val) => {
                val = val + "/s/"; // Using /s/ as a seperator between each query param value to work around query param values containing commas.
                finalValArr.push(val);
            });
        }
        else {
            finalValArr.push(value);
        }

        if(value.length === 0) {
            searchParams.delete(param);
        }
        else {
            searchParams.set(param, finalValArr);
        }
    } else searchParams.delete(param);
    window.history.pushState("", "", newURL.href);
}

export function resetURLQueryParams() {
    const newURL = window.location.href.split("?")[0];
    window.history.replaceState({}, "", newURL);
}

export function getQueryParams(colName) {
    /**
     * Function is supposed to return query params that will be could be loaded into local storage.
     * (Takes precedence over current local storage.) (To be used for filters only, since they are seperated by /s/, use getUrlParam() for sortBy.)
     */

    const vals = getUrlParam(colName);

    let queryParamVals = vals ? vals.split("/s/,") : null;
    if (queryParamVals) queryParamVals = queryParamVals.map((q) => q.replace("/s/", ""));
    return queryParamVals;
}

export function getUrlParam(param) {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    let paramValues = searchParams.get(param);
    return paramValues;
}


export function extractQueryParams(url){
  if (!url) {
    return {};
  }

  return (/^[?#]/.test(url) ? url.slice(1) : url)
    .split("&")
    .reduce((params, param) => {
      let [key, value] = param.split("=");
      params[key] = value
        ? decodeURIComponent(value.replace(/\+/g, " "))
        : "";
      return params;
    }, {});
}


// WEBPACK FOOTER //
// ./utils/url.js